import { Observable, observe, Scope } from 'wdc-cube'

@Observable
export class WaitingScope extends Scope {
    @observe() text = ''
}
